import React from "react";
import { Typography } from "@c4c-web/ui";
import { MapPinIcon } from "@c4c-web/icons";
import { cn } from "@c4c-web/libs-hooks/libs";
import {
  getMainText,
  getSubText,
  getVariant,
  pinInfoVariants,
} from "../../../utils";
import type { IPinInfo } from "./map.interface";

export const PinInfo: React.FC<IPinInfo> = ({
  emirate,
  town,
  isAreaSupported = true,
  isConfirmAddress,
  showPin,
  t,
}) => {
  return (
    <div className="absolute left-[44%] top-[42%] z-50 size-[50px]">
      <MapPinIcon
        color="c4red-400"
        height={isConfirmAddress ? "48" : "56"}
        size="custom"
        variant="filled"
        width={isConfirmAddress ? "48" : "56"}
      />
      {showPin ? (
        <div
          className={cn(
            pinInfoVariants({
              variant: getVariant(isAreaSupported, isConfirmAddress),
            }),
          )}
        >
          <Typography
            className="text-white"
            variant={isConfirmAddress ? "xs" : "sm"}
            weight={isConfirmAddress ? "regular" : "bold"}
          >
            {getMainText(isAreaSupported, isConfirmAddress, t)}
          </Typography>
          <Typography
            className="line-clamp-2 px-1 text-center text-white"
            variant={isConfirmAddress ? "sm" : "xs"}
          >
            {getSubText(emirate, town, isAreaSupported, isConfirmAddress, t)}
          </Typography>
          {/* Tooltip Arrow */}
          {isAreaSupported && !isConfirmAddress ? (
            <div className="absolute top-full size-0 border-x-8 border-t-[15px] border-x-transparent border-t-gray-800 ltr:left-1/2 ltr:-translate-x-1/2 rtl:right-1/2 rtl:translate-x-1/2" />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
